
<template>
    <div>
       <div style="border: 1px solid #e9e9e9; border-radius: 1rem;">
            <q-card-section>
                <div class="text-bold" style="font-size: 16px;">{{$t("stepper.title9")}}</div>
            </q-card-section>
            <q-separator style="margin: 0 0.75rem; width: auto;"/>
            <q-card-section>
                <div class="q-pb-md secondaryHeader" >
                   {{$t("Fatca-Detail.declaration")}}
                </div>

                <div class="row q-pb-md">
                    <div class="col-xs-12 col-md-3 text-bold q-pr-md">
                               {{$t("Fatca-Detail.taxresidency")}}
                    </div>
                    <div class="col-xs-12 col-md-9 ">
                       {{StoreStateFATCA.TaxResidency}}
                    </div>
                </div>

                 <q-separator style="margin-bottom: 16px;"/>

                <div class="q-pb-md secondaryHeader" >
                   {{$t("Fatca-Detail.tindetails")}}
                </div>
                
                <div v-for="tininfo in StoreStateAOD.FATCAInformation.TINInformation" v-bind:key="tininfo.index">
                    <div class="row q-pb-md contentLabel">
                        <div class="col-xs-12 col-md-3 text-bold q-pr-md">
                            {{$t("Fatca-Detail.country")}}
                        </div>
                        <div class="col-xs-12 col-md-9 ">
                            {{tininfo.TaxResidency_CountryName}}
                        </div>
                        <div class="col-xs-12 col-md-3 text-bold q-pr-md">
                            {{$t("Fatca-Detail.no")}}
                        </div>
                        <div class="col-xs-12 col-md-9 ">
                            {{tininfo.TaxResidency_TIN}}
                        </div>
                    </div>
                    <div class="row q-pb-sm contentLabel">
                        <div class="col-xs-12 col-md-3 text-bold q-pr-md">
                            {{$t("Fatca-Detail.unavailablereason")}}
                        </div>
                        <div class="col-xs-12 col-md-9 ">
                            {{tininfo.TaxResidency_UnavailableReason}}
                        </div>
                        <div class="col-xs-12 col-md-3 text-bold q-pr-md">
                            {{$t("Fatca-Detail.reasonBexplain")}}
                        </div>
                        <div class="col-xs-12 col-md-9 ">
                            {{tininfo.TaxResidency_ReasonB}}
                        </div>
                    </div>
                </div>
                <div class="row q-pb-sm contentLabel">
                    <div class="col-xs-12 col-md-3 text-bold q-pr-md">
                        {{$t("Fatca-Detail.usresident")}}
                    </div>
                    <div class="col-xs-12 col-md-9 ">
                        {{StoreStateFATCA.UsResident}}
                    </div>
                    <!---<div class="col-2">
                        Type Of US Resident
                    </div>
                    <div class="col">
                        : {{StoreStateFATCA.USResidentIndicia}}
                    </div>--->
                </div>
            </q-card-section>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import store from '../store'
export default {
    name : 'SummaryFATCAInformation',
    data() {
        return {
            StoreStateAOD : store.state.AOD,
            StoreStateFATCA : store.state.FATCA
        }
    },
    computed: {

    },
    methods: {

    },
    mounted(){
    }
    
}
</script>

<style lang="stylus">
.upper{
    text-transform: uppercase;
}
</style>